import * as React from 'react';

interface SettingsProps {
  name: React.ReactNode;
  description: React.ReactNode;
  children: React.ReactNode;
}

export function Setting({ name, description, children }: SettingsProps) {
  return (
    <>
      <div className="flex flex-col gap-2">
        {name}
        {description}
      </div>
      {children}
    </>
  );
}

interface SettingNameProps {
  children: React.ReactNode;
}

Setting.Name = function SettingName({ children }: SettingNameProps) {
  return (
    <div className="flex gap-2 text-base font-sans font-400 text-blue-900 leading-8">
      {children}
    </div>
  );
};

interface SettingDescriptionProps {
  children: React.ReactNode;
}

Setting.Description = function SettingDescription({
  children,
}: SettingDescriptionProps) {
  return (
    <div className="text-xs font-sans font-400 text-grey-900 leading-6">
      {children}
    </div>
  );
};

interface SettingControlProps {
  children: React.ReactNode;
}

Setting.Control = function SettingControl({ children }: SettingControlProps) {
  return <div className="flex flex-col-reverse">{children}</div>;
};
